module.exports = __webpack_public_path__ + "static/media/ic_download.05421cd4.svg";